import React from 'react'

const List = () => {
  return (
    <div>
      <ul>
        <li>- To promote use of farmer clubs to share ideas and experiences</li>
        <li className='mt-2'>- To promote Agribusiness and sustainable agriculture</li>
        <li className='mt-2'>- To Offer solutions to agricultural challenges faced by farmers</li>
        <li className='mt-2'>- To Promote use of new and improved farming methodologies</li>
        <li className='mt-2'>- To Promote use of Agricultural machinery</li>
        <li className='mt-2'>- To Promote climate smart agriculture</li>
        <li className='mt-2'>- Increase access to young farmers to micro-saving and Banking services</li>
      </ul>
    </div>
  )
}

export default List
